'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EQ, IN } from 'reporting-data/constants/operators';
import RevenueAttributionCardV2 from './RevenueAttributionCardV2';
import { CONTENT_TYPE_MAP } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const ASSET_ID_PROPERTY = 'hs_asset_id';
function ContentRevenueAttributionCard({
  allowDrilldown,
  analyticsPageId,
  analyticsPageIds,
  contentType,
  dateRange,
  hasRevenueAttributionAccess,
  useInlineLabels = true
}) {
  const [assetIdFilter, setAssetIdFilter] = useState(null);
  useEffect(() => {
    const getAssetIdFilter = () => {
      if (analyticsPageId) {
        return {
          operator: EQ,
          property: ASSET_ID_PROPERTY,
          value: analyticsPageId
        };
      } else if (analyticsPageIds.size > 0) {
        return {
          operator: IN,
          property: ASSET_ID_PROPERTY,
          values: analyticsPageIds
        };
      }
      return null;
    };
    setAssetIdFilter(getAssetIdFilter());
  }, [analyticsPageId, analyticsPageIds]);
  const filters = [assetIdFilter, {
    operator: EQ,
    property: 'hs_asset_type',
    value: CONTENT_TYPE_MAP[contentType]
  }];
  return assetIdFilter ? /*#__PURE__*/_jsx(RevenueAttributionCardV2, {
    allowDrilldown: allowDrilldown,
    filters: filters,
    dateRange: dateRange,
    hasRevenueAttributionAccess: hasRevenueAttributionAccess,
    screen: CONTENT_TYPE_MAP[contentType],
    useInlineLabels: useInlineLabels
  }) : null;
}
ContentRevenueAttributionCard.propTypes = {
  allowDrilldown: PropTypes.bool,
  analyticsPageId: PropTypes.string,
  analyticsPageIds: PropTypes.instanceOf(List),
  contentType: PropTypes.string,
  dateRange: PropTypes.instanceOf(ImmutableMap).isRequired,
  hasRevenueAttributionAccess: PropTypes.bool.isRequired,
  useInlineLabels: PropTypes.bool
};
export default ContentRevenueAttributionCard;